import { useNavigate } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme";
import { Colors } from "../../utils/colors";
import { MARKIT_DOCS } from "@markit/common.utils";
import { NavigationId } from "../../navigation/AppParamList";

type InternationalNumberNoticeProp = {
  signIn: boolean;
};

// Used for places where user enters phone number for verification. If international number, it shows this notice instead.
const InternationalNumberNotice = (props: InternationalNumberNoticeProp) => {
  const { signIn } = props;
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="ColumnNormal" style={{ gap: 7 }}>
      <span className="LoginHeaderText" style={{ ...theme.PrimaryText }}>
        {signIn ? "Unsupported Number" : "Agree to Continue"}
      </span>
      {signIn ? (
        <div className="ColumnNormal" style={{ gap: 7 }}>
          <span className="LoginHeaderTextDescription">
            Markit does not currently support logins to non U.S. or Canada (+1)
            phone numbers.
          </span>
          <span style={{ color: Colors.GRAY2, fontSize: 10 }}>
            Please{" "}
            <span
              style={{ ...theme.PrimaryText, cursor: "pointer" }}
              onClick={() => navigate(NavigationId.WELCOME)}
            >
              login with an email account
            </span>{" "}
            if you are a creator or visit a Markit product page directly to
            enter your number, which bypasses login.
          </span>
          <span style={{ color: Colors.GRAY2, fontSize: 10 }}>
            Visit our{" "}
            <span
              style={{ ...theme.PrimaryText, cursor: "pointer" }}
              onClick={() =>
                window.open(MARKIT_DOCS + "/contactsupport", "_blank")
              }
            >
              support page
            </span>{" "}
            if you have questions.
          </span>
        </div>
      ) : (
        <span className="LoginHeaderTextDescription">
          Markit does not support sms for non U.S. or Canada (+1) phone numbers.
          You may continue but you will not receive texts until we add
          additional support.
        </span>
      )}
    </div>
  );
};

export default InternationalNumberNotice;
